/* eslint-disable react/forbid-dom-props */
import { CSSProperties } from "react";

import LinkWithIcon from "@vfuk/core-link-with-icon";
import type { LinkWithIconProps } from "@vfuk/core-link-with-icon/dist/LinkWithIcon.types";

export interface IconLinkProps extends LinkWithIconProps {
  isDisabled?: boolean;
}

export const IconLink = (props: IconLinkProps) => {
  const { isDisabled, ...rest } = props;

  const disabledStyles: CSSProperties = {
    pointerEvents: "none",
    opacity: 0.4,
    userSelect: "none",
  };

  return (
    <div style={isDisabled ? disabledStyles : undefined}>
      <LinkWithIcon {...rest} />
    </div>
  );
};
